// v2.12.0 — SponsoredBadge : 4 tiers visuels distincts.
// Utilisé dans JusticeCard + HealthCard pour mettre en avant les profils payants.
// Si tier="free" → ne rend rien (null). Sinon → petit chip coloré au-dessus du nom.

const STYLES = {
  partner: {
    label: "🏆 PARTENAIRE OFFICIEL",
    background: "linear-gradient(135deg, #FCD34D, #F59E0B)",
    color: "#7C2D12",
    border: "1px solid rgba(124, 45, 18, 0.35)",
    boxShadow: "0 2px 6px rgba(245, 158, 11, 0.35)",
  },
  premium: {
    label: "⭐ Premium",
    background: "linear-gradient(135deg, #C7D2FE, #818CF8)",
    color: "#1E1B4B",
    border: "1px solid rgba(99, 102, 241, 0.4)",
    boxShadow: "0 2px 5px rgba(129, 140, 248, 0.3)",
  },
  basic: {
    label: "✓ Vérifié",
    background: "#9CA3AF",
    color: "#111827",
    border: "1px solid rgba(156, 163, 175, 0.5)",
    boxShadow: "none",
  },
};

export default function SponsoredBadge({ tier, size = "md", testId }) {
  const style = STYLES[tier];
  if (!style) return null; // free → invisible
  const padX = size === "sm" ? 6 : 8;
  const fontSize = size === "sm" ? 9 : 9.5;
  return (
    <span
      data-testid={testId || `sponsored-badge-${tier}`}
      style={{
        display: "inline-block",
        background: style.background,
        color: style.color,
        border: style.border,
        boxShadow: style.boxShadow,
        padding: `2px ${padX}px`,
        borderRadius: 999,
        fontSize,
        fontWeight: 800,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
    >
      {style.label}
    </span>
  );
}

export function VerifiedTick({ size = "md", testId }) {
  const dim = size === "sm" ? 12 : 14;
  return (
    <span
      data-testid={testId || "verified-tick"}
      title="Vérifié par l'équipe CIV-AI"
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        width: dim, height: dim, borderRadius: "50%",
        background: "#0EA5E9", color: "#fff",
        fontSize: dim * 0.65, fontWeight: 900, lineHeight: 1,
        marginLeft: 6, flexShrink: 0,
      }}
    >✓</span>
  );
}
